import { render, staticRenderFns } from "./SinglePrior.vue?vue&type=template&id=771bd91b&"
import script from "./SinglePrior.vue?vue&type=script&lang=js&"
export * from "./SinglePrior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports